<div class="collapsibleTitle pageTitle">
  <div class="collapseButtonContainer pb-0">
    <button
      type="button"
      *ngIf="compareOpened"
      class="submitSearchButton"
      (click)="compareOpened = !compareOpened"
    >
      <em class="fas fa-angle-up"></em>
    </button>
    <button
      type="button"
      *ngIf="!compareOpened"
      class="submitSearchButton"
      (click)="compareOpened = !compareOpened"
    >
      <em class="fas fa-angle-down"></em>
    </button>
    <div class="pageTitle collapsibleTitle">
      <div class="title halfTitle">Comparar versiones</div>
    </div>
  </div>
</div>

<div *ngIf="compareOpened">
  <div class="wrapper">
    <div class="firstPart version">
      <label>Versión 1</label>
    </div>
    <div class="secondPart">
      <select [(ngModel)]="release1.value">
        <option *ngFor="let release of listReleases">
          {{ release.release }}
        </option>
      </select>
    </div>

    <div class="firstPart version">
      <label>Versión 2</label>
    </div>
    <div class="secondPart">
      <select [(ngModel)]="release2.value">
        <option *ngFor="let release of listReleases">
          {{ release.release }}
        </option>
      </select>
    </div>
    <div class="compareButton">
      <button class="formButton" type="button" (click)="loadReleases()">
        Comparar
      </button>
    </div>
  </div>

  <div class="halfGroupVersions">
    <div *ngIf="release1.loaded" class="halfGroup">
      <div class="halfTitle title"><strong>Datos de solicitud</strong></div>

      <app-form-fields [fields]="fieldsSolicitudR1"></app-form-fields>

      <div class="halfTitle title"><strong>Datos de vehículo</strong></div>
      <app-form-fields
        *ngIf="
          release1.data.tipoCertificado != 'CM' &&
          release1.data.peTcertificado != 'CML'
        "
        [fields]="fieldsVehiculoR1"
      ></app-form-fields>

      <div
        class="bastidoresCoC"
        *ngIf="
          release1.data.tipoCertificado == 'CM' ||
          release1.data.peTcertificado == 'CML'
        "
      >
        <table>
          <caption style="display: none">
            Texto prueba
          </caption>
          <thead>
            <th>Número de bastidor</th>
            <th>Fecha primera matriculación</th>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of release1.bastidoresCOC">
              <tr>
                <td>{{ item.bcBastidor }}</td>
                <td>{{ item.bcFechaPriMatric | date : "dd/MM/yyyy" }}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <div class="halfTitle title"><strong>Datos concretos</strong></div>
      <app-dynamic-fields
        [operation]="'detail'"
        [fields]="release1.fieldsDynamic"
        [stateToPFAndWatchBoth]="true"
        (downloadFileEvent)="downloadFile($event, release1)"
      ></app-dynamic-fields>

      <div *ngIf="type == 'Placa'">
        <div class="halfTitle title"><strong>Datos Placa</strong></div>
        <div *ngFor="let item of release1.dataPlaca" class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label>{{ item.ciId }}</label>
              </div>
            </div>
            <div class="inputContainer">
              <div class="labelAsInput">
                <label>{{ item.value }}</label>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>

      <div *ngIf="release1.data.tipoCertificado == 'OD'">
        <div class="halfTitle title">
          <strong>Detalles de solicitud</strong>
        </div>
        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label>Documentación</label>
              </div>
            </div>
            <div class="inputContainer">
              <div class="labelAsInput">
                <label>{{ release1.data.peFnameFichaTecnica }}</label>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>

    <div *ngIf="release2.loaded" class="halfGroup">
      <div class="halfTitle title"><strong>Datos de solicitud</strong></div>

      <app-form-fields [fields]="fieldsSolicitudR2"></app-form-fields>

      <div class="halfTitle title"><strong>Datos de vehículo</strong></div>

      <app-form-fields
        *ngIf="
          release2.data.tipoCertificado != 'CM' &&
          release2.data.peTcertificado != 'CML'
        "
        [fields]="fieldsVehiculoR2"
      ></app-form-fields>

      <div
        class="bastidoresCoC"
        *ngIf="
          release2.data.tipoCertificado == 'CM' ||
          release2.data.peTcertificado == 'CML'
        "
      >
        <table>
          <caption style="display: none">
            Texto prueba
          </caption>
          <thead>
            <th>Número de bastidor</th>
            <th>Fecha primera matriculación</th>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of release2.bastidoresCOC">
              <tr>
                <td>{{ item.bcBastidor }}</td>
                <td>{{ item.bcFechaPriMatric | date : "dd/MM/yyyy" }}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <div class="halfTitle title"><strong>Datos concretos</strong></div>
      <app-dynamic-fields
        [operation]="'detail'"
        [fields]="release2.fieldsDynamic"
        [stateToPFAndWatchBoth]="true"
        (downloadFileEvent)="downloadFile($event, release2)"
      ></app-dynamic-fields>

      <div *ngIf="type == 'Placa'">
        <div class="halfTitle title"><strong>Datos Placa</strong></div>
        <div *ngFor="let item of release2.dataPlaca" class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label>{{ item.ciId }}</label>
              </div>
            </div>
            <div class="inputContainer">
              <div class="labelAsInput">
                <label>{{ item.value }}</label>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>

      <div *ngIf="release2.data.tipoCertificado == 'OD'">
        <div class="halfTitle title">
          <strong>Detalles de solicitud</strong>
        </div>
        <div class="row compressedRow">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label>Documentación</label>
              </div>
            </div>
            <div class="inputContainer">
              <div class="labelAsInput">
                <label>{{ release2.data.peFnameFichaTecnica }}</label>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>
  </div>
</div>
